export function slugifyHeading(text) {
  return (text || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

const HEADING_REGEX = /^(#{2,3})\s+(.+?)\s*$/gm;

function extractMarkdownHeadings(markdown) {
  if (!markdown) return [];

  const headings = [];
  let match;
  HEADING_REGEX.lastIndex = 0;

  while ((match = HEADING_REGEX.exec(markdown)) !== null) {
    const level = match[1].length;
    const text = match[2].replace(/[*_`]/g, '').trim();
    if (text) {
      headings.push({ level, text, id: slugifyHeading(text) });
    }
  }

  return headings;
}

export function buildTocFromContent(content) {
  if (!Array.isArray(content)) return [];

  const items = [];

  content.forEach((block, blockIndex) => {
    if (!block) return;

    if (block.__typename === 'ComponentComponentsRichTextMarkdown') {
      const headings = extractMarkdownHeadings(block.richTextMarkdownContent);
      headings.forEach((heading) => {
        items.push({
          id: heading.id,
          label: heading.text,
          level: heading.level
        });
      });
      return;
    }

    if (block.__typename === 'ComponentGlossarySegmentsShowcase' && block.title) {
      items.push({
        id: slugifyHeading(block.title) || `segments-${blockIndex}`,
        label: block.title,
        level: 2
      });
      return;
    }

    if (block.__typename === 'ComponentGlossaryFaq' && block.title) {
      items.push({
        id: slugifyHeading(block.title) || `faq-${blockIndex}`,
        label: block.title,
        level: 2
      });
    }
  });

  return items;
}
